


















































import Vue from "vue";
import Component from "vue-class-component";
import { CommunityInterface } from "@/types";
import CommunityCallout from "@/components/community/CommunityCallout.vue";

@Component({ components: { CommunityCallout } })
export default class AffiliatedCommunities extends Vue {
  private communities: CommunityInterface[] = [];

  get affiliatedCommunities(): CommunityInterface[] {
    return this.communities.filter((c) => !c.mainCommunity);
  }

  public async mounted() {
    try {
      const response = await this.axios.get("/community/communities");
      this.communities = response.data;
    } catch {
      // silently ignore if endpoint unavailable
    }
  }
}
